import type { FC } from 'react'
import { useState } from 'react'
import cn from 'classnames'
import { Link } from 'components/ui'
import { useRouter } from 'next/router'
import { ChevronDown, ChevronUp } from 'components/icons'
import type { FilterLinkProps } from '.'
import s from './filter-link.module.css'

const FilterLink: FC<FilterLinkProps> = ({
  baseUrl,
  preserveQuery = true,
  className,
  filters,
  vertical = false,
  callback,
}) => {
  const router = useRouter()

  const [open, setOpen] = useState<string[]>([])

  if (!filters) {
    return <></>
  }

  function toggle(slug: string) {
    if (open.includes(slug)) {
      const nextOpen = open.filter((e: string) => e !== slug)
      setOpen([...nextOpen])
    } else {
      const nextOpen = open
      nextOpen.push(slug)
      setOpen([...nextOpen])
    }
  }

  const currentQuery = preserveQuery ? router.query : {}
  currentQuery.page = '1'

  return (
    <ul className={cn(s.root, className)}>
      {filters.map(({ id, slug, name, categories }) => (
        <li key={`filter-link-${id}`}>
          {categories && categories.length > 0 ? (
            <button type="button" className={s.filterLink}>
              <Link onClick={callback} href={{ pathname: `${baseUrl}${slug}`, query: currentQuery }}>
                {name}
              </Link>
              <button onClick={() => toggle(slug)} type="button">
                {open.includes(slug) ? <ChevronUp /> : <ChevronDown />}
              </button>
            </button>
          ) : (
            <Link
              onClick={callback}
              href={{ pathname: `${baseUrl}${slug}`, query: currentQuery }}
              className={s.filterLink}
            >
              {name}
            </Link>
          )}

          {open.includes(slug) && (
            <ul className={cn(vertical && s.vertical, s.subcategory)}>
              {categories &&
                categories.length > 0 &&
                categories.map((sub) => (
                  <Link
                    onClick={callback}
                    href={{ pathname: `${baseUrl}${sub.slug}`, query: currentQuery }}
                    className={s.filterLink}
                  >
                    {sub.name}
                  </Link>
                ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  )
}

export default FilterLink
